import type { ChatSettings } from '../types';

export const defaults: Partial<ChatSettings> = {
  accountId: '',
  bubbleIcon: {
    url: 'https://static.elfsight.com/icons/chats-discord.svg'
  },
  buttonText: 'Chat on Discord',
  buttonBorderRadius: 8,
  welcomeMessage:
    "Did you know that this widget can help you provide support, consult customers, do sales, collect feedback and build customer relationships?<br><br>Drop me a line and I'll tell you how 🤩",
  bubbleBackgroundColor: 'rgb(255, 255, 255)',
  bubbleIconColor: '#7289da',
  headerBackgroundColor: 'rgb(255, 255, 255)'
};
